const BASE_URL_V2 = '/api/v2';

export const API_URLS = {
  PATIENT_INFO: `${BASE_URL_V2}/patient-report/patient-info`,
  REPORT_FLOW: (locale: string) => `${BASE_URL_V2}/patient-report/report-flow/${locale}`,
  REPORT_ALERTS: `${BASE_URL_V2}/patient-report/report-alerts`,
  REPORT: `${BASE_URL_V2}/patient-report/report`,
  LOGIN: `${BASE_URL_V2}/patient-report/login`,
  CONSENT: `${BASE_URL_V2}/patient-report/consent`
};
